var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticStyle:{"opacity":"1 !important"}},[_c('compact-picker',{attrs:{"value":_vm.chosenColor,"palette":_vm.colorspallete},on:{"input":function (val) {
        _vm.chosenColor = val;
        _vm.$emit('input', _vm.chosenColor);
        _vm.$emit('hide');
      }}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }